import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RemoteRecord } from '@client/common/redux/RemoteRecord';
import { useCheckPermissions } from '@client/context/hooks';
import { getIsLoggedIn } from '@client/context/redux/redux';
import { fetchCostCentersMisconfigured, selectCostCentersMisconfigured } from '@client/myAccount/costCenters/redux/costCenters';
import { CostCentersMisconfiguredType } from 'b2b-common/core/account/api/costCenters/CostCenters.types';
import { PERMISSION } from 'b2b-common/core/context/Context.types';

export const useCostCentersMisconfiguredEffect = (): {
  misconfiguredData: RemoteRecord<CostCentersMisconfiguredType[]>,
  hasMisconfiguredCC: boolean,
} => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn);
  const misconfiguredData = useSelector(selectCostCentersMisconfigured);
  const hasMisconfiguredCC = !!misconfiguredData?.data?.length;
  const { wasStarted } = misconfiguredData;
  const canCostCenterCanReview = useCheckPermissions([PERMISSION.costCenterCanReview]);

  useEffect((): void => {
    if (isLoggedIn && canCostCenterCanReview && !wasStarted) {
      dispatch(fetchCostCentersMisconfigured());
    }
  }, []);

  return {
    misconfiguredData,
    hasMisconfiguredCC,
  };
};
